// Оболочка UI v3 (README §1): верхняя полоса 40, под ней боковое меню и
// рабочая область раздела. Адаптивна для всех ширин (§12): на телефоне меню —
// шторка поверх, полосы 56 нет.
//
// Разделы берутся из sections/registry.ts. Разделы с keepAlive (Беседы,
// Мессенджеры, Заметки) после первого показа остаются смонтированными и
// прячутся CSS'ом: окна держат WebSocket, документ — несохранённые правки.

import { Suspense, useEffect, useState } from 'react'
import { useAppStore } from '../store/appStore'
import { MOBILE_QUERY, useMediaQuery } from '../lib/useMediaQuery'
import { resolveSection, SECTIONS } from '../sections/registry'
import type { SectionDef } from '../sections/types'
import ErrorBoundary from './ErrorBoundary'
import SideNav from './SideNav'
import Toast from './Toast'
import TopBar from './TopBar'
import './shell.css'

export default function Shell() {
  const section = useAppStore((s) => s.section)
  const setMobSide = useAppStore((s) => s.setMobSide)
  const mobile = useMediaQuery(MOBILE_QUERY)
  const active = resolveSection(section)

  // Разделы keepAlive, которые уже открывали: монтируем один раз и держим.
  const [kept, setKept] = useState<string[]>(() => (active.keepAlive ? [active.id] : []))
  useEffect(() => {
    if (active.keepAlive && !kept.includes(active.id)) setKept((k) => [...k, active.id])
  }, [active, kept])

  // Шторка не должна пережить уход с телефонной ширины и Esc.
  useEffect(() => {
    if (!mobile) setMobSide(false)
  }, [mobile, setMobSide])
  useEffect(() => {
    if (!mobile) return
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMobSide(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [mobile, setMobSide])

  const keptDefs = SECTIONS.filter((s) => s.keepAlive && kept.includes(s.id))

  return (
    <div className={`abx-app${mobile ? ' is-phone' : ''}`}>
      <TopBar />
      <div className="abx-body">
        <SideNav />
        <main className="abx-main">
          {keptDefs.map((def) => (
            <SectionView key={def.id} def={def} on={def.id === active.id} />
          ))}
          {active.keepAlive ? null : <SectionView key={section} def={active} on />}
          <Toast />
        </main>
      </div>
    </div>
  )
}

function SectionView({ def, on }: { def: SectionDef; on: boolean }) {
  const View = def.View
  return (
    <div className={`abx-view${on ? ' is-on' : ''}`} data-section={def.id}>
      <ErrorBoundary scope={`раздел «${def.title}»`}>
        <Suspense fallback={<div className="abx-view__loading">загрузка…</div>}>
          <View />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
